module.exports = __webpack_public_path__ + "static/media/mqtt_protocol.ad367185.md";